<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="title"
             :icon="icon">
    <!-- body -->
    <div class="mb-4 d-flex flex-column justify-content-center the-warning">
      <h4 class="mb-4">
        A {{ getItemLabel(true) }} will be created with the below information.
      </h4>
      <uploader-profile-example v-if="uploader_profile" :uploader-profile="uploader_profile" :file-name="file_name" />
    </div>
    <!-- footer/controls -->
    <template slot="body-controls">
      <b-button type="button" class="btn-ss-standout" @click="() => close(true)">
        Approve
      </b-button>
      <b-button type="button" class="btn-ss-cancel" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModalMixin from 'VueModals/VjsModalMixin';
import UploaderProfileExample from "VuePartials/App/ThirdPartyUploader/UploaderProfileExample";
import UploaderProfilesMixin from "VueMixins/UploaderProfilesMixin";

export default {
  components: {
    UploaderProfileExample,
  },
  mixins: [VjsModalMixin, UploaderProfilesMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'third-party-upload-approve',
    },
    title: {
      type: String,
      required: false,
      default: 'Upload Approval',
    },
    icon: {
      type: String,
      required: false,
      default: 'flaticon2-warning',
    },
    uploaderProfile: {
      type: Object,
      required: false,
      default: null,
    },
    storageAsset: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: function () {
    return {
      uploader_profile: this.uploaderProfile,
    };
  },
  computed: {
    file_name() {
      return this.storageAsset?.name;
    },
  },
  watch: {
    uploader_profile: function (new_val) {
      if (new_val) {
        if (new_val.settings?.publish_duration) {
          this.uploader_profile.settings.publish_duration = this.convertSecondsToDaysHoursMinutes(new_val.settings.publish_duration);
        }

        if (new_val.settings?.publish_delay) {
          this.uploader_profile.settings.publish_delay = this.convertSecondsToDaysHoursMinutes(new_val.settings.publish_delay);
        }
      }
    },
  },
  methods: {
    close(approved) {
      this.complete({
        success: approved,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.the-warning {
  h4 {
    display: inline-block;
    text-align: center;
  }
}
</style>
